import VirtualLot from "./VirtualLot";

export default VirtualLot;